const parseTime = (datetime) => {
  if (!datetime) {
    return null
  }

  try {
    const date = new Date(datetime)
    return date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch (error) {
    return null
  }
}

export default parseTime
